/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent provider
==========================================================================================*/


export default [
	{
		url: "/shopping",
		name: "Compras",
		slug: "shopping",
		icon: "ShoppingCartIcon",
	},
	{
		url: null,
		name: "Proveedores",
		slug: "dashboard",
		icon: "TruckIcon",
		i18n: "Proveedores",
		submenu: [
			{
				url: '/products',
				name: "Productos",
				slug: "Productos",
				i18n: "Productos",
			},
			{
				url: '/provider',
				name: "Afiliados",
				slug: "Afiliados",
				i18n: "Afiliados",
			}
		]
	},
	{
		url: null,
		name: "Clientes",
		slug: "dashboard",
		icon: "UsersIcon",
		i18n: "Clientes",
		submenu: [
			{
				url: '/containers',
				name: "Contenedores",
				slug: "Contenedores",
				i18n: "Contenedores",
				icon: "ShoppingCartIcon",
			},
			{
				url: '/clients',
				name: "Afiliados",
				slug: "Afiliados",
				i18n: "Afiliados",
			}
		]
	},
	{
		url: "/containersType",
		name: "Contenedores",
		slug: "containers",
		icon: "BoxIcon",
	},
	{
		url: '/simulation',
		name: "Simulador",
		slug: "Simulador",
		i18n: "Simulador",
		icon: "CodesandboxIcon",
	},
	{
		url: "/company",
		name: "Misceláneos",
		slug: "clients",
		icon: "SettingsIcon",
	}

]
